// Frontend permissions constants - should match backend
// Resource-based permissions structure
const Resources = Object.freeze({
  USER: "user",
  ROLE: "role",
  JOB: "job",
  COVER_LETTER: "cover_letter",
  MESSAGE_BOARD: "message_board",
  INVITATION: "invitation",
  AUDIT_LOG: "audit_log",
  ANALYTICS: "analytics",
  PROPOSAL: "proposal",
  PORTFOLIO: "portfolio",
  VECTOR_DATA: "vector_data",
  TENANT_CONFIG: "tenant_config",
  JOB_FILTERS: "job_filters",
  UPWORK_CREDENTIALS: "upwork_credentials",
});

const Actions = Object.freeze({
  CREATE: "create",
  READ: "read",
  UPDATE: "update",
  DELETE: "delete",
  INVITE: "invite",
  APPLY: "apply",
  VIEW: "view",
  EXPORT: "export",
  REVIEW: "review",
  SUBMIT: "submit",
});

// Generate all possible permissions
const Permissions = Object.freeze({
  // User permissions
  USER_CREATE: `${Resources.USER}:${Actions.CREATE}`,
  USER_READ: `${Resources.USER}:${Actions.READ}`,
  USER_UPDATE: `${Resources.USER}:${Actions.UPDATE}`,
  USER_DELETE: `${Resources.USER}:${Actions.DELETE}`,
  USER_INVITE: `${Resources.USER}:${Actions.INVITE}`,

  // Role permissions
  ROLE_CREATE: `${Resources.ROLE}:${Actions.CREATE}`,
  ROLE_READ: `${Resources.ROLE}:${Actions.READ}`,
  ROLE_UPDATE: `${Resources.ROLE}:${Actions.UPDATE}`,
  ROLE_DELETE: `${Resources.ROLE}:${Actions.DELETE}`,

  // Job permissions
  JOB_READ: `${Resources.JOB}:${Actions.READ}`,
  JOB_APPLY: `${Resources.JOB}:${Actions.APPLY}`,

  // Cover letter permissions
  COVER_LETTER_CREATE: `${Resources.COVER_LETTER}:${Actions.CREATE}`,
  COVER_LETTER_READ: `${Resources.COVER_LETTER}:${Actions.READ}`,
  COVER_LETTER_UPDATE: `${Resources.COVER_LETTER}:${Actions.UPDATE}`,
  COVER_LETTER_DELETE: `${Resources.COVER_LETTER}:${Actions.DELETE}`,

  // Message board permissions
  MESSAGE_BOARD_READ: `${Resources.MESSAGE_BOARD}:${Actions.READ}`,
  MESSAGE_BOARD_CREATE: `${Resources.MESSAGE_BOARD}:${Actions.CREATE}`,

  // Invitation permissions
  INVITATION_CREATE: `${Resources.INVITATION}:${Actions.CREATE}`,
  INVITATION_READ: `${Resources.INVITATION}:${Actions.READ}`,

  // Audit log permissions
  AUDIT_LOG_READ: `${Resources.AUDIT_LOG}:${Actions.READ}`,
  AUDIT_LOG_EXPORT: `${Resources.AUDIT_LOG}:${Actions.EXPORT}`,

  // Analytics permissions
  ANALYTICS_READ: `${Resources.ANALYTICS}:${Actions.READ}`,
  ANALYTICS_EXPORT: `${Resources.ANALYTICS}:${Actions.EXPORT}`,

  UPWORK_ACTION_APPROVE: 'upwork_action:approve',

  // Proposal permissions
  PROPOSAL_CREATE: `${Resources.PROPOSAL}:${Actions.CREATE}`,
  PROPOSAL_READ: `${Resources.PROPOSAL}:${Actions.READ}`,
  PROPOSAL_UPDATE: `${Resources.PROPOSAL}:${Actions.UPDATE}`,
  PROPOSAL_DELETE: `${Resources.PROPOSAL}:${Actions.DELETE}`,
  PROPOSAL_REVIEW: `${Resources.PROPOSAL}:${Actions.REVIEW}`,
  PROPOSAL_SUBMIT: `${Resources.PROPOSAL}:${Actions.SUBMIT}`,

  // Portfolio permissions
  PORTFOLIO_CREATE: `${Resources.PORTFOLIO}:${Actions.CREATE}`,
  PORTFOLIO_READ: `${Resources.PORTFOLIO}:${Actions.READ}`,
  PORTFOLIO_UPDATE: `${Resources.PORTFOLIO}:${Actions.UPDATE}`,
  PORTFOLIO_DELETE: `${Resources.PORTFOLIO}:${Actions.DELETE}`,

  // Vector data permissions
  VECTOR_DATA_CREATE: `${Resources.VECTOR_DATA}:${Actions.CREATE}`,
  VECTOR_DATA_READ: `${Resources.VECTOR_DATA}:${Actions.READ}`,
  VECTOR_DATA_UPDATE: `${Resources.VECTOR_DATA}:${Actions.UPDATE}`,
  VECTOR_DATA_DELETE: `${Resources.VECTOR_DATA}:${Actions.DELETE}`,

  // Tenant configuration permissions
  TENANT_CONFIG_READ: `${Resources.TENANT_CONFIG}:${Actions.READ}`,
  TENANT_CONFIG_UPDATE: `${Resources.TENANT_CONFIG}:${Actions.UPDATE}`,
  JOB_FILTERS_READ: `${Resources.JOB_FILTERS}:${Actions.READ}`,
  JOB_FILTERS_UPDATE: `${Resources.JOB_FILTERS}:${Actions.UPDATE}`,
  UPWORK_CREDENTIALS_READ: `${Resources.UPWORK_CREDENTIALS}:${Actions.READ}`,
  UPWORK_CREDENTIALS_UPDATE: `${Resources.UPWORK_CREDENTIALS}:${Actions.UPDATE}`,

  // System-level (owner) permissions
  SYSTEM_TENANT_MANAGE: `system:tenant_manage`,
});

function getAllPermissions() {
  return Object.values(Permissions);
}

export { Resources, Actions, Permissions, getAllPermissions };
